import {message} from 'ant-design-vue';
export const doMessage = (content = '请检查网络连接，请稍后重试', type = 'error', duration = 2) =>{
    if (type === 'error') {
        message.error({
            class: 'ant-message-center',
            content,
            duration,
        });
    } else if (type === 'info') {
        message.info({
            class: 'ant-message-center',
            content,
            duration
        });
    } else if (type === 'success') {
        message.success({
            class: 'ant-message-center',
            content,
            duration
        });
    }
};
